import { createSelector } from '@reduxjs/toolkit';

import { LECTURE_CONTENT_TYPES } from '@classCreation/data/lectureContentTypes';
import { LESSON_TYPES } from '@classCreation/data/lessonTypes';

const baseSelector = (state) => state.createClassForm;

export const classTypeSelector = createSelector(
  (state) => baseSelector(state).classType,
  (classType) => classType
);

export const academyProjectModalStageSelector = (state) =>
  baseSelector(state).academyProjectModalStage;

export const classFormSelector = createSelector(
  (state) => baseSelector(state),
  (classForm) => classForm
);

export const academyTopicInputSelector = createSelector(
  (state) => baseSelector(state).academyTopicInput,
  (academyTopicInput) => academyTopicInput
);

export const preLectureContentSelector = createSelector(
  (state) => baseSelector(state).preLectureContent,
  (preLectureContent) => preLectureContent
);

export const postLectureContentSelector = createSelector(
  (state) => baseSelector(state).postLectureContent,
  (postLectureContent) => postLectureContent
);

export const literatureResourceSelector = createSelector(
  (state) => baseSelector(state).literatureResource,
  (literatureResource) => literatureResource
);

export const courseGroupSelector = createSelector(
  (state) => baseSelector(state).courseGroup,
  (courseGroup) => courseGroup
);

export const contestTypeSelector = createSelector(
  (state) => baseSelector(state).contestType,
  (contestType) => contestType
);

export const liveLectureSelector = createSelector(
  (state) => baseSelector(state).liveLecture,
  (liveLecture) => liveLecture
);

export const classTagSelector = createSelector(
  (state) => baseSelector(state).classTag,
  (classTag) => classTag
);

export const preReadSelector = createSelector(
  (state) => baseSelector(state).preRead,
  (preRead) => preRead
);

export const assignmentSelector = createSelector(
  (state) => baseSelector(state).assignment,
  (assignment) => assignment
);

export const homeworkSelector = createSelector(
  (state) => baseSelector(state).homework,
  (homework) => homework
);

export const contestSelector = createSelector(
  (state) => baseSelector(state).contest,
  (contest) => contest
);

export const academyProjectSelector = createSelector(
  (state) => baseSelector(state).academyProject,
  (academyProject) => academyProject
);

export const lectureContentsSelector = createSelector(
  (state) => baseSelector(state),
  (classForm) => ({
    [LECTURE_CONTENT_TYPES.preLecture]: classForm.preLectureContent,
    [LECTURE_CONTENT_TYPES.postLecture]: classForm.postLectureContent,
    [LECTURE_CONTENT_TYPES.literatureResource]: classForm.literatureResource,
  })
);

export const lessonsSelector = createSelector(
  (state) => baseSelector(state),
  (classForm) => ({
    [LESSON_TYPES.assignment]: classForm.assignment,
    [LESSON_TYPES.homework]: classForm.homework,
    [LESSON_TYPES.liveLecture]: classForm.liveLecture,
    [LESSON_TYPES.preRead]: classForm.preRead,
    [LESSON_TYPES.contest]: classForm.contest,
  })
);
